import SearchPickProjectPresenter from "./SearchPickProjectPresenter";

export const SearchPickProject = SearchPickProjectPresenter;

export default SearchPickProject;